import { render, staticRenderFns } from "./reviseRecordInfo.vue?vue&type=template&id=e17ddf04&"
import script from "./reviseRecordInfo.vue?vue&type=script&lang=js&"
export * from "./reviseRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./reviseRecordInfo.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports